/**
 * IndustryCountersBar — scope counters + total entity counts.
 */
import React from 'react';
import { Globe, Layers, Grid3X3, Monitor, AlertTriangle } from 'lucide-react';
import { useT } from '../../i18n/I18nContext.jsx';

export function IndustryCountersBar({ counters, matrix, visibleIndustries, dirty }) {
  const t = useT();
  return (
    <div className="industry-matrix-counters" style={{
      display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: 12,
      color: 'var(--text-secondary, #475569)',
      padding: '8px 12px', borderRadius: 6,
      background: 'var(--surface-2)', border: '1px solid var(--erp-border, #e2e8f0)'
    }}>
      <div>
        <Globe   size={12} color="#0ea5e9" />
        {' '}<strong style={{ color: '#0ea5e9' }}>{counters.common}</strong>
        {' '}{t('erp.industryMatrix.counter.common', 'Common')}
      </div>
      <div>
        <Layers  size={12} color="#8b5cf6" />
        {' '}<strong style={{ color: '#8b5cf6' }}>{counters.cross}</strong>
        {' '}{t('erp.industryMatrix.counter.cross', 'Cross-industry')}
      </div>
      <div>
        <Grid3X3 size={12} color="#10b981" />
        {' '}<strong style={{ color: '#10b981' }}>{counters.vertical}</strong>
        {' '}{t('erp.industryMatrix.counter.vertical', 'Vertical')}
      </div>
      <div>
        <Monitor size={12} />
        {' '}{matrix.modules.length}M · {matrix.subModules.length}S · {matrix.screens.length}Sc {t('erp.industryMatrix.counter.total', 'total')}
      </div>
      <div>
        {visibleIndustries.length}/{matrix.industries.length} {t('erp.industryMatrix.counter.industriesVisible', 'industries visible')}
      </div>
      {dirty && (
        <div style={{ color: '#b45309', fontWeight: 700 }}>
          <AlertTriangle size={12} /> {t('erp.industryMatrix.unsaved', 'unsaved changes')}
        </div>
      )}
    </div>
  );
}
